__turbopack_context__.v({
  "className": "syne_603d855f-module__Kngo_a__className",
  "variable": "syne_603d855f-module__Kngo_a__variable",
});
